export default {
  sportsbook: "đại lý thể thao",
  login_page: "Trang đại lý thể thao",
  first_time_page: "Lần đăng nhập đầu tiên",
  security_page: "An ninh xác thực",
  account_settings: "Cài đặt tài khoản",
  new_login: "Đăng nhập mới",
  two_step_verification: "Xác minh hai bước",
  account_information: "Thông tin tài khoản",
  commission_settings: "Cài đặt hoa hồng",
  bet_limit_settings: "Cài đặt giới hạn cược",
  position_taking_settings: "Cài đặt phần thầu",
  update_profile: "Cập nhật hồ sơ",
  update_password: "Cập nhật Mật khẩu",
  update_security: "Cập nhật mã bảo vệ",
  account_profile: "Thông tin tài khoản cá nhân",
  account_creation: "Tạo tài khoản",
  profile_settings: "Cài đặt cấu hình",

  otp_page: "Trang OTP",
  unbind_otp_2fa: "Hủy liên kết OTP 2FA",
};